import { forwardRef } from 'react';

interface ErrorDialogProps {
    message: string;
}

const ErrorDialog = forwardRef<HTMLDivElement, ErrorDialogProps>(({ message }, ref) => {
   return <div ref={ref} className="custom-error flex items-center gap-4">
        <span className="text-xl" aria-hidden="true">⚠️</span>
        <p>{message}</p>
    </div>
});

export default ErrorDialog;